import { type FC, useState } from "react";

import { Button, Headline, Input, Small, WYSIWYG } from "@fronterahealth/frontera-ui-components";

interface AddCriteriaFormProps {
  onSubmit: (name: string, category: string, content: string) => Promise<void>;
  onCancel: () => void;
  isSubmitting: boolean;
}

export const AddCriteriaForm: FC<AddCriteriaFormProps> = ({ onSubmit, onCancel, isSubmitting }) => {
  const [name, setName] = useState("");
  const [category, setCategory] = useState("");
  const [content, setContent] = useState("");

  const handleSubmit = async () => {
    if (!name.trim() || !content.trim()) return;
    await onSubmit(name.trim(), category.trim(), content.trim());
    setName("");
    setCategory("");
    setContent("");
  };

  return (
    <div className="mt-6 w-full rounded-lg border border-gray-200 bg-white p-6 shadow-xs">
      <Headline size="medium">New Criteria</Headline>
      <div className="mt-4">
        <Input
          name="criteria-name"
          label="Name"
          placeholder="Enter criteria name"
          value={name}
          onChange={(e) => setName(e.target.value)}
        />
      </div>
      <div className="mt-4">
        <Input
          name="criteria-category"
          label="Category"
          placeholder="Enter category"
          value={category}
          onChange={(e) => setCategory(e.target.value)}
        />
      </div>
      <div className="mt-4">
        <Small displayType="loud">Content</Small>
        <div className="mt-1">
          <WYSIWYG
            title=""
            placeholder="Enter criteria content"
            existingContent={content}
            onSave={async ({ content: c }) => setContent(c)}
            autoSave
            isSaving={false}
          />
        </div>
      </div>
      <div className="mt-4 flex gap-3">
        <Button
          appearance="primary"
          text="Create"
          onClick={handleSubmit}
          disabled={isSubmitting || !name.trim() || !content.trim()}
        />
        <Button appearance="secondary" text="Cancel" onClick={onCancel} />
      </div>
    </div>
  );
};
